<section class="flex h-full flex-col gap-4">
  <section class="border border-neutral-20 px-4 py-4">
    <label for="outlook-contact-sync-toggle" class="flex items-center gap-3">
      <span
        class="inline-flex"
        kendoTooltip
        position="top"
        [title]="'outlookSync.contact.syncDirectionTooltip' | translate"
      >
        <kendo-switch
          id="outlook-contact-sync-toggle"
          [formControl]="form().controls.contactsSyncEnabled"
        ></kendo-switch>
      </span>
      <span class="font-semibold text-component-text">
        {{ 'outlookSync.contact.syncTitle' | translate }}
      </span>
    </label>

    <p class="mt-2 text-sm text-component-text">
      <strong>{{ 'outlookSync.syncDirection.label' | translate }}</strong>
      {{ 'outlookSync.contact.syncDirection' | translate }}
    </p>

    <section class="mt-4 flex flex-wrap items-end gap-4">
      <label for="outlook-contact-category" class="flex min-w-0 flex-col gap-1.5">
        <span class="text-sm font-semibold text-component-text">
          {{
            'outlookSync.contact.outlookCategoryLabel' | translate
          }}
        </span>
        <kendo-dropdownlist
          id="outlook-contact-category"
          class="w-64"
          [data]="outlookCategoryOptions()"
          textField="label"
          valueField="id"
          [valuePrimitive]="true"
          [formControl]="outlookCategoryControl"
          [disabled]="true"
        ></kendo-dropdownlist>
      </label>

      <span
        class="fa-icons icon-20 icon-arrow-right-arrow-left mb-2 flex-shrink-0 text-neutral-70"
        aria-hidden="true"
      ></span>

      <label for="outlook-contact-maximizer-list" class="flex min-w-0 flex-col gap-1.5">
        <span class="text-sm font-semibold text-component-text">
          {{
            'outlookSync.contact.maximizerListLabel' | translate
          }}
        </span>
        <kendo-dropdownlist
          id="outlook-contact-maximizer-list"
          class="w-64"
          [data]="favoriteListOptions()"
          textField="label"
          valueField="id"
          [valuePrimitive]="true"
          [formControl]="favoriteListControl"
        ></kendo-dropdownlist>
      </label>
    </section>

    <p class="mt-4 flex items-center gap-2 text-sm text-neutral-70">
      <span class="fa-icons icon-10 icon-circle-info" aria-hidden="true"></span>
      {{ 'outlookSync.contact.note' | translate: { minutes: syncFrequency.intervalMinutes } }}
    </p>
  </section>

  <maximizer-history-grid
    [history]="history()"
    [loading]="historyLoading()"
    [showIgnored]="true"
    [boxed]="false"
    (refresh)="refreshHistory()"
  ></maximizer-history-grid>
</section>
